import React from "react";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";
import {Button, ButtonGroup} from "semantic-ui-react";
import AssociatedServicesAndSourcesTable from "./AssociatedServicesAndSourcesTable";

export default class CountryDetailInfo extends React.Component {

    static propTypes = {
        countryDetail: PropTypes.object,
        associatedKYCData: PropTypes.array,
        associatedKYBData: PropTypes.array,
    }

    render() {

        const {countryDetail, associatedKYCData, associatedKYBData} = this.props;

        return(
            <div className={"detail-container"}>
                <div className={"countries-container"}>
                    <ButtonGroup>
                        <Button
                            content="Overview"
                        />
                    </ButtonGroup>
                    <div className="detail-info">
                        <div>
                            <span>{"Details:"}</span>
                            <p>{"KYC Status: "}{countryDetail.country_detail.kyc_status}</p>
                            <p>{"KYC Tier: "}{countryDetail.country_detail.kyc_tier}</p>
                        </div>
                        <div>
                            <span>{"Product Support:"}</span>
                            <p>{"1x1 Support: YES"}</p>
                            <p>{"2x2 Support: "}{countryDetail.country_detail.number_2x2_support ? "YES" : "NO"}</p>
                            <p>{"Age Support: "}{countryDetail.country_detail.age_support ? "YES" : "NO"}</p>
                            <p>{"BV Support: "}{countryDetail.country_detail.bv_support ? "YES" : "NO"}</p>
                            <p>{"BV+ Support: "}{countryDetail.country_detail.bv_plus_support ? "YES" : "NO"}</p>
                        </div>
                        <div>
                            <span>{"Indicative Match Rates:"}</span>
                            <p>{"1x1 Match Rate: "}{countryDetail.country_detail.number_1x1_match_rate}{"%"} </p>
                            <p>{"2x2 Match Rate: "}{countryDetail.country_detail.number_2x2_match_rate}{"%"} </p>
                        </div>
                        <div>
                            <h3>Notes:</h3>
                                {countryDetail && countryDetail.notes.length > 0
                                    ? countryDetail.notes.map((note, idx) => {
                                        const labelText = note.type === "External"
                                            ? "Notes For The Customer: "
                                            : "Internal GDC Notes: "
                                        return (
                                            <div key={idx}>
                                                <span>{labelText}</span>
                                                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note.note) }} />
                                            </div>
                                        )
                                    }) : (
                                        <div>
                                            <p>
                                                Not Available.
                                                Please Add Notes.
                                            </p>
                                        </div>
                                    )
                                }
                        </div>
                    </div>
                </div>

                <AssociatedServicesAndSourcesTable
                    associatedKYCData={associatedKYCData}
                    associatedKYBData={associatedKYBData}
                />
            </div>
        );
    }

}
